import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class TelService {
constructor(private http: Http) { }
 private tagsUrl = 'https://tel.siloq.com/';
 private syncUrl = 'https://sync.siloq.com/';

 tel(d: string) {
	 return this.http.get(this.tagsUrl + "crawl/?d=" + d )
	 .map( (res:Response) => {
	       res.text();
	      })
	      .subscribe(data => {console.log(data)});
     }

 syncSearch(d: string) {
 return this.http.get(this.syncUrl + "syncdb/search/" + d )
	 .map( (res:Response) => {
	       res.text();
	      })
	      .subscribe(data => {console.log(data)});
     }

 syncAuto(d: string) {
 return this.http.get(this.syncUrl + "syncdb/auto/" + d )
	 .map( (res:Response) => {
	       res.text();
	      })
	      .subscribe(data => {console.log(data)});
     }
}



// WEBPACK FOOTER //
// ./src/app/services/tel.service.ts